export interface PermissionGroup {
  id: number;
  icon?: string;
  title: string;
  brief: string;
  permissions: string[];
  /** OBIE permissions required whenever this group is selected */
  requires?: string[];
}

export const permissionGroups: PermissionGroup[] = [
  {
    id: 1,
    title: 'Your accounts',
    brief:
      'For you to use this service E-DocOnline needs to access information from your accounts at your bank.',
    permissions: ['ReadAccountsDetail'],
  },
  {
    id: 2,
    title: 'Your transactions',
    brief:
      'For you to use this service E-DocOnline needs to access information from your accounts at your bank.',
    permissions: [
      'ReadTransactionsCredits',
      'ReadTransactionsDebits',
      'ReadTransactionsDetail',
    ],
    requires: ['ReadAccountsDetail'],
  },
  {
    id: 3,
    title: 'Your statement',
    brief:
      'For you to use this service E-DocOnline needs to access information from your accounts at your bank.',
    permissions: ['ReadStatementsDetail', 'ReadStatementsBasic'],
    requires: ['ReadAccountsDetail'],
  },
  {
    id: 4,
    title: 'Your balances',
    brief:
      'For you to use this service E-DocOnline needs to access information from your accounts at your bank.',
    permissions: ['ReadBalances'],
    requires: ['ReadAccountsDetail'],
  },
];

export function buildPermissionsFromGroups(
  checkedTitles: Record<string, boolean>,
): string[] {
  const selected = new Set<string>();

  permissionGroups.forEach((group) => {
    if (!checkedTitles[group.title]) {
      return;
    }
    group.permissions.forEach((permission) => selected.add(permission));
    (group.requires || []).forEach((permission) => selected.add(permission));
  });

  return Array.from(selected);
}

export function groupsFromPermissions(permissions: string[]): Record<string, boolean> {
  const checked: Record<string, boolean> = {};

  permissionGroups.forEach((group) => {
    const groupPerms = [
      ...group.permissions,
      ...(group.requires || []),
    ];
    checked[group.title] = group.permissions.every((permission) =>
      permissions.includes(permission),
    );
  });

  return checked;
}
